// extracted by mini-css-extract-plugin
module.exports = {"mapWrapper":"MapComponent_mapWrapper__1k2qo","mapContainer":"MapComponent_mapContainer__T0yTa","loaderWrapper":"MapComponent_loaderWrapper__1bZ1i"};